import { useState } from 'react'
import { Modal, TextInput, Select, Button } from '@mantine/core'
import { useForm } from '@mantine/form'
import Box from '@/components/ui/Box'
import RetailerSelect from '@/components/ui/RetailerSelect'

export default function ServiceCaseCustomer({ serviceCase, updateServiceCase }) {
    const { customer_info_string } = serviceCase
    const [opened, setOpened] = useState(false)
    const [loading, setLoading] = useState(false)
    const [selectedRetailer, setSelectedRetailer] = useState(null)

    const form = useForm({
        initialValues: {
            customer_name: serviceCase.customer_name || '',
            customer_email: serviceCase.customer_email || '',
            customer_phone: serviceCase.customer_phone || '',
            customer_locale: serviceCase.customer_locale || 'fr',
        },
    })

    const handleOpen = () => {
        form.setValues({
            customer_name: serviceCase.customer_name || '',
            customer_email: serviceCase.customer_email || '',
            customer_phone: serviceCase.customer_phone || '',
            customer_locale: serviceCase.customer_locale || 'fr',
        })
        setSelectedRetailer(serviceCase.retailer ?? null)
        setOpened(true)
    }

    const handleRetailerSelect = (retailer) => {
        setSelectedRetailer(retailer ?? null)
    }

    const handleRetailerClear = () => {
        setSelectedRetailer(null)
    }

    const handleSubmit = async (values) => {
        setLoading(true)
        await updateServiceCase({
            ...values,
            retailer_id: selectedRetailer ? parseInt(selectedRetailer.id, 10) : null,
        })
        setLoading(false)
        setOpened(false)
    }

    return (
        <>
            <Box
                title="Client"
                globalAction={true}
                action={handleOpen}
                actionLabel="Modifier le client"
            >
                <div className="flex flex-col">
                    <span>
                        {serviceCase.customer_name || 'Client non renseigné'}
                    </span>

                    <span className="text-gray-500">
                        {customer_info_string || 'Pas de coordonnées'}
                    </span>

                    {serviceCase.retailer && (
                        <span className="text-gray-500 text-sm mt-1">
                            Revendeur : {serviceCase.retailer.name}
                        </span>
                    )}
                </div>
            </Box>

            <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                title="Modifier le client"
                centered
            >
                <form
                    onSubmit={form.onSubmit(handleSubmit)}
                    className="flex flex-col gap-3"
                >
                    <TextInput
                        label="Nom"
                        {...form.getInputProps('customer_name')}
                    />
                    <TextInput
                        label="Email"
                        type="email"
                        {...form.getInputProps('customer_email')}
                    />
                    <TextInput
                        label="Téléphone"
                        {...form.getInputProps('customer_phone')}
                    />
                    <Select
                        label="Langue"
                        data={[
                            { value: 'fr', label: 'Français' },
                            { value: 'en', label: 'Anglais' },
                        ]}
                        {...form.getInputProps('customer_locale')}
                    />

                    <div className="flex flex-col gap-1">
                        {selectedRetailer ? (
                            <div className="flex flex-col gap-1">
                                <span className="text-sm font-medium">Revendeur associé</span>
                                <div className="flex items-center justify-between text-sm bg-gray-50 border rounded-md px-3 py-2">
                                    <span>{selectedRetailer.name}</span>
                                    <button
                                        type="button"
                                        className="text-gray-400 hover:text-gray-600"
                                        onClick={handleRetailerClear}
                                    >
                                        ✕
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <RetailerSelect
                                label="Revendeur associé"
                                placeholder="Rechercher un revendeur..."
                                onSelect={handleRetailerSelect}
                            />
                        )}
                    </div>

                    <Button type="submit" fullWidth mt="sm" loading={loading}>
                        Enregistrer
                    </Button>
                </form>
            </Modal>
        </>
    )
}
